import { ChoiceEdit } from '@powerportalspro/react-fluent';

export function ChoiceEditMainSample() {
  return <ChoiceEdit columnName="ppp_favoritecolor" />;
}
